import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInputComponent} from 'ngx-material-file-input';
import {ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';
import moment from 'moment';
import {delay, first, takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {FileBase64} from '../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';
import {Dictionary} from '../../../../shared/interface/dictionary';
import {DICT_TYPE_REGISTRATION_ID_TYPE, DictService} from '../../../../shared/services/dict.service';

@Component({
  selector: 'app-redirection-import',
  templateUrl: './redirection-import.component.html',
  styleUrls: ['./redirection-import.component.scss']
})
export class RedirectionImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  importCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  commissionRedirectionImportFormValid = false;
  commissionRedirectionImportForm: FormGroup;
  companyControl: FormControl;
  insuranceCompanyControl: FormControl;
  fileControl: FormControl;
  fileMaxSize = 5242880 * 8;
  processingRequest = false;
  formErrors = {};
  selectedInsuranceCompany: InsuranceCompany;
  registrationIdTypes: Dictionary[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private commissionRedirectionService: CommissionRedirectionService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private dictService: DictService,
  ) {
    const date = moment();
    date.startOf('month');

    this.commissionRedirectionImportForm = fb.group({
      name: fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      fileContent: fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.commissionRedirectionImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.commissionRedirectionImportFormValid = this.commissionRedirectionImportForm.valid;
      });

    this.companyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((companyId: number) => this.importCompanyId.next(companyId));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  import(): void {
    if (!this.commissionRedirectionImportForm.valid) {
      this.commissionRedirectionImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.commissionRedirectionImportForm, this.formErrors);
    this.formErrors = {};

    const formData = {...this.commissionRedirectionImportForm.value};

    this.commissionRedirectionService.import(formData)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Rozpoczynanie importowania danych', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/przepiecia-polis/lista-importow']);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas tworzenia importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.commissionRedirectionImportForm, this.formErrors);
        }
      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }

  fileSelected(file: FileBase64): void {
    this.commissionRedirectionImportForm.get('fileContent').setValue(file.base64);
    this.commissionRedirectionImportForm.get('name').setValue(file.filename);
  }

  loadIdDict(): void {
    this.registrationIdTypes = [];

    this.dictService.getDictSubject()
      .pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.forEach((dict: Dictionary) => {
          if (
            dict.type === DICT_TYPE_REGISTRATION_ID_TYPE && this.selectedInsuranceCompany
            && this.selectedInsuranceCompany.identificationIdTypes.includes(dict.key)
          ) {
            this.registrationIdTypes.push(dict);
          }
        });
      });
  }

}
